[
  {
    "code": "KY-BT",
    "name": "Bodden Town"
  },
  {
    "code": "KY-CB",
    "name": "Cayman Brac"
  },
  {
    "code": "KY-EE",
    "name": "East End"
  },
  {
    "code": "KY-GT",
    "name": "George Town"
  },
  {
    "code": "KY-SO",
    "name": "Little Cayman"
  },
  {
    "code": "KY-NS",
    "name": "North Side"
  },
  {
    "code": "KY-WB",
    "name": "West Bay"
  }
]